import { Button, Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { ProviderHistoryModalDto } from "../../../Core/Api/Types/db-object-provider-history-infos";
import DataTable, { CellSize } from "../../Table/table";
import { useTranslation } from "react-i18next";

export type ModalProviderHistoryElementProps = {
    assetId: number;
    historyData: ProviderHistoryModalDto[];
};
export type ModalProviderHistoryProps = CommonModalProps<ModalProviderHistoryElementProps>;

const ModalProviderHistory = forwardRef<any, ModalProviderHistoryProps>((props, ref) => {
    const { t } = useTranslation();
    const { assetId, historyData, closeModal } = props;

    const gridDefinition: GridColDef[] = [
        {
            headerName: t("common:date"),
            field: "date",
            minWidth: CellSize.medium,
            flex: CellSize.medium,
        },
        {
            headerName: t("common:provider"),
            field: "provider",
            minWidth: CellSize.medium,
            flex: CellSize.medium,
        },
        {
            headerName: t("common:user"),
            field: "user",
            minWidth: CellSize.medium,
            flex: CellSize.medium,
        },
    ];

    return (
        <Modal
            reference={ref}
            title={t("modal:title.assetProviderHistory", { assetId })}
            closeModal={closeModal}
            width={800}
            footer={
                <Stack direction="row" justifyContent="flex-end">
                    <Button variant="outlined" onClick={closeModal}>
                        {t("common:close")}
                    </Button>
                </Stack>
            }
        >
            <DataTable
                noControls
                columns={gridDefinition}
                rows={historyData}
                pagination={false}
                disableRowSelectionOnClick
                initialState={{
                    sorting: {
                        sortModel: [{ field: "date", sort: "desc" }],
                    },
                    pinnedColumns: { left: ["__check__"], right: ["actions"] },
                }}
            />
        </Modal>
    );
});

export default ModalProviderHistory;
